import React, { useMemo } from 'react'
import { format, isBefore, subYears } from 'date-fns'
import { ModifiedAppointmentType } from './InfoContainerTabs'
import { useCrmContext } from '../../contexts/crmContext'

type HistoryDataType = { date?: string; participantCount: number; info: string; trainer: string | undefined }

export const HistoryInfo = ({ appointments, finishedPresentations }: { appointments: ModifiedAppointmentType[], finishedPresentations: any }) => {
  const { isUserCallcenter } = useCrmContext()
  const historyData = useMemo(() => {
    let data: HistoryDataType[] = []

    appointments.forEach(({ date: rawDate, isCancelled, isVisit, isCompleted, status }) => {
      const date = rawDate ? format(rawDate, 'dd.MM.yyyy') : undefined

      if (rawDate && !isBefore(rawDate, new Date())) {
        return
      }

      if (isCompleted) {
        const twoYearsAgo = subYears(new Date(), 2)

        const finished = finishedPresentations
          ?.filter((presentation: any) => {
            const presentationDateObj = new Date(presentation.endtime)
            if (isBefore(presentationDateObj, twoYearsAgo)) return false

            const presentationDate = format(presentationDateObj, 'dd.MM.yyyy')
            return presentationDate === date
          })
        ?.reduce((result: HistoryDataType[], current: any) => {
          const trainerName = current.trainer?.name ?? ''
          const projectName = current.project?.name ?? ''
          const existingEntry = result.find((entry) => entry.trainer === trainerName)
      
          if (existingEntry) {
            existingEntry.participantCount += current.adjusted_number_of_participants
            if (!existingEntry.info.includes(projectName)) {
              existingEntry.info += `, ${projectName}`
            }
          } else {
            result.push({
              date,
              participantCount: current.adjusted_number_of_participants,
              info: projectName,
              trainer: trainerName,
            })
          }
      
          return result
        }, []) ?? []
      

        data = data.concat(finished)
      }

      if (isCancelled || isVisit) {
        data.push({
          date,
          participantCount: 0,
          trainer: undefined,
          info: isCancelled ? 'abgesagt' : `Besuch: ${status?.label}`,
        })
      }
    })

    return data
  }, [appointments])

  return (
    <>
      {!historyData.length && <div>Keine Einträge vorhanden</div>}
      {isUserCallcenter && historyData.length ? (
        <div>
          <strong>{historyData[historyData.length - 1].date}</strong>
          {` - ${historyData[historyData.length - 1].participantCount} Tln - ${
            historyData[historyData.length - 1].trainer
              ? historyData[historyData.length - 1].trainer
              : historyData[historyData.length - 1].info
          }${
            historyData[historyData.length - 1].trainer
              ? ' - ' + historyData[historyData.length - 1].info
              : ''
          }`}
        </div>
      ) : (
        historyData.map(({ date, participantCount, trainer, info }, idx) => (
          <div key={idx}>
            <strong>{date}</strong>
            {` - ${participantCount} Tln - ${trainer ? trainer : info}${trainer ? ' - ' + info : ''}`}
          </div>
        ))
      )}
    </>
  )  
}
